<template>
  <div class="ma-4">
    <v-sheet v-show="showSkeleton" class="pa-3">
      <v-skeleton-loader class="mx-auto" type="table" />
    </v-sheet>

    <div v-show="!showSkeleton" class="text-h4 mb-2">Tokens</div>
    <v-data-iterator
      v-show="!showSkeleton"
      :no-data-text="noDataText"
      :items="dataTokens"
      :items-per-page.sync="itemsPerPage"
      :page="page"
      :search="search"
      :no-results-text="noResultsText"
      hide-default-footer
    >
      <template v-slot:header>
        <v-row>
          <v-col cols="7" class="my-2">
            <v-btn
              dark
              color="orangePcm"
              href="/controle-de-acesso/token/criar"
              target="_blank"
              @click="handleGoToNewToken"
            >
              Criar Token
            </v-btn>
          </v-col>
          <v-col cols="4" class="mr-2">
            <v-text-field v-model="search" clearable hide-details prepend-inner-icon="mdi-magnify" label="Busca" />
          </v-col>
        </v-row>
      </template>
      <template v-slot:default="props">
        <v-data-table
          dense
          :headers="headers"
          :items="props.items"
          hide-default-footer
          class="elevation-1"
          disable-pagination
        >
          <template v-slot:[`item.botoes`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon @click="deletar(item)" dark color="darkRed" v-bind="attrs" v-on="on">
                  <v-icon>mdi-trash-can-outline</v-icon>
                </v-btn>
              </template>
              <span>Remover</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </template>

      <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <div class="ml-4 mb-2 grey--text">
            <p>Total de Tokens: {{ qtdTokens }}</p>
          </div>
          <v-spacer />
          <div class="pb-5">
            <ListPagination
              :page="page"
              :numberOfPages="numberOfPages"
              @firstPage="firstPage"
              @formerPage="formerPage"
              @nextPage="nextPage"
              @lastPage="lastPage"
            />
          </div>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ListPagination from '@/componentes/ListPagination'
import { registerVuexModule } from '@/utils/vuexUtils'
import { pagesHomeMixins } from '@/mixins/pagesHomeMixins'

import tokensStore from '../_store'
import tokenHttpServices from '../_services/tokenHttpServices'

export default {
  name: 'TokenHome',
  components: { ListPagination },
  mixins: [pagesHomeMixins],
  data: () => ({
    dataTokens: [],
    headers: [
      {
        text: 'Token',
        value: 'name',
        align: 'left',
      },
      {
        text: 'Ações',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
  }),

  computed: {
    ...mapGetters('tokenHomeModuleUsersStore', ['getAllTokens']),

    numberOfPages() {
      return Math.ceil(this.dataTokens.length / this.itemsPerPage)
    },
    qtdTokens() {
      return this.dataTokens.length
    },
  },

  async created() {
    registerVuexModule(this.$store, 'tokenHomeModuleUsersStore', tokensStore)
    await this.listAllTokens()
    this.dataTokens = [...this.getAllTokens]

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('tokenHomeModuleUsersStore', ['listAllTokens']),

    handleGoToNewToken(event) {
      event.preventDefault()
      if (event.metaKey || event.ctrlKey) {
        const goToNewToken = this.$router.resolve({ name: 'TokenHome/criar' })
        window.open(goToNewToken.href, '_blank')
      } else {
        this.$router.push({ name: 'TokenHome/criar' })
      }
    },

    async deletar(item) {
      let resultado = window.confirm(`Deseja remover o token "${item.name}"?`)
      if (resultado) {
        try {
          await tokenHttpServices.deleteToken(item._id)
          this.dataTokens = this.dataTokens.filter(x => x._id !== item._id)
        } catch (error) {
          alert(error.response.data)
        }
      }
    },
  },
}
</script>
